import { useHistory } from 'react-router-dom';

import { Divider, Heading, Modal } from '@zillow/constellation-10';
import { LeaseArtifactType } from '@zg-rentals/ts-leasing-client';

import { StyledZDocsEditor } from '../../constants/styleConstants';
import { useLeaseQuery, useLeaseSummaryQuery, useMarkAsSignedMutation, usePreviewUrlQuery } from '../../utils/queries';
import type { LeaseAction } from '../../models';
import LeaseActionButtonGroup from '../../components/LeaseActions/LeaseActionButtonGroup';
import { useRecoilState } from 'recoil';
import { isSigningCompleteModalOpenState } from '../../../atoms';
import { SigningCompleteModal } from '../../components/LeaseRenewal/Tenant/SigningCompleteModal';
import LeaseExtension from '../../models/LeaseExtension';
import { useLeasingUrlParams } from '../../hooks';

export function RenewalPDFViewer() {
  const [, setIsSigningCompleteModalOpen] = useRecoilState(isSigningCompleteModalOpenState);

  const history = useHistory();
  const { leaseId, renewalId } = useLeasingUrlParams();

  const leaseQuery = useLeaseQuery(leaseId);
  const previewUrlQuery = usePreviewUrlQuery(renewalId, LeaseArtifactType.LEASE_EXTENSION_RENEWAL);
  const leaseSummaryQuery = useLeaseSummaryQuery(renewalId, LeaseArtifactType.LEASE_EXTENSION_RENEWAL);
  const markAsSignedMutation = useMarkAsSignedMutation();

  function onClose() {
    history.push(LeaseExtension.getSummaryPath(leaseId, renewalId));
  }

  function onSigningComplete() {
    markAsSignedMutation.mutateAsync({
      postData: {
        leaseArtifactId: renewalId,
        leaseArtifactType: LeaseArtifactType.LEASE_EXTENSION_RENEWAL,
      },
    });
    setIsSigningCompleteModalOpen(true);
  }

  return (
    <>
      <Modal.Root
        size="fullScreen"
        open
        onOpenChange={(open) => {
          if (!open) {
            onClose();
          }
        }}
        useDismissProps={{ escapeKey: false, outsidePress: false }}
      >
        <Modal.Portal>
          <Modal.Backdrop>
            <Modal.Content>
              <Modal.Header>
                <Heading level={1}>Your lease renewal agreement</Heading>
              </Modal.Header>
              <Divider />
              <Modal.Body css={{ padding: '0 !important' }}>
                {previewUrlQuery.data?.url && (
                  <StyledZDocsEditor onDocumentSaved={onSigningComplete} url={previewUrlQuery.data.url} />
                )}
              </Modal.Body>
              <Divider />
              <Modal.Footer>
                <LeaseActionButtonGroup
                  leaseActions={leaseSummaryQuery?.data?.documentActions as Array<LeaseAction>}
                  lease={leaseQuery?.data}
                  isTop={false}
                />
              </Modal.Footer>
              <Modal.CloseButton />
            </Modal.Content>
          </Modal.Backdrop>
        </Modal.Portal>
      </Modal.Root>
      <SigningCompleteModal />
    </>
  );
}
